import { render } from "./SignatureNodeView.vue?vue&type=template&id=3836e3b2&scoped=true"
import script from "./SignatureNodeView.vue?vue&type=script&lang=js"
export * from "./SignatureNodeView.vue?vue&type=script&lang=js"

import "./SignatureNodeView.vue?vue&type=style&index=0&id=3836e3b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3836e3b2"]])

export default __exports__